import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { createSelector } from 'reselect'
import { RootState } from 'redux/store'

export enum AccessCodeRedemptionStatus {
    INITIAL = 'INITIAL',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    PENDING = 'PENDING',
}

export enum SignInStatus {
    INITIAL = 'INITIAL',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    PENDING = 'PENDING',
}

interface AccessCodeState {
    errorMessage: string
    status: AccessCodeRedemptionStatus
    currentCode: string
    signInStatus: string
}

export const initialState: AccessCodeState = {
    errorMessage: '',
    status: AccessCodeRedemptionStatus.INITIAL,
    currentCode: '',
    signInStatus: SignInStatus.INITIAL,
}

const passesSlice = createSlice({
    name: 'accessCode',
    initialState,
    reducers: {
        resetState: _ => initialState,
    },
    extraReducers: {
        'accessCode/signUp/pending': state => {
            state.signInStatus = SignInStatus.PENDING
        },
        'accessCode/signUp/rejected': (state, action: PayloadAction<string>) => {
            state.signInStatus = SignInStatus.ERROR
            state.status = AccessCodeRedemptionStatus.ERROR
            state.errorMessage = action.payload
        },
        'accessCode/signUp/fulfilled': state => {
            state.signInStatus = SignInStatus.SUCCESS
        },

        'accessCode/signIn/pending': state => {
            state.signInStatus = SignInStatus.PENDING
        },
        'accessCode/signIn/rejected': (state, action: PayloadAction<string>) => {
            state.signInStatus = SignInStatus.ERROR
            state.status = AccessCodeRedemptionStatus.ERROR
            state.errorMessage = action.payload
        },
        'accessCode/signIn/fulfilled': state => {
            state.signInStatus = SignInStatus.SUCCESS
        },

        'accessCode/validateAccessCode/pending': state => {
            state.status = AccessCodeRedemptionStatus.PENDING
        },
        'accessCode/validateAccessCode/fulfilled': state => {
            state.status = AccessCodeRedemptionStatus.SUCCESS
        },
        'accessCode/validateAccessCode/rejected': (
            state,
            action: PayloadAction<{ message: string; currentCode: string }>,
        ) => {
            state.status = AccessCodeRedemptionStatus.ERROR
            state.errorMessage = action.payload.message
            state.currentCode = action.payload.currentCode
        },
    },
})

const { actions, reducer } = passesSlice
export default reducer

export const getAccessCode = (store: RootState) => store.accessCode
export const getStatus = createSelector(getAccessCode, accessCode => accessCode.status)
export const getErrorMessage = createSelector(getAccessCode, accessCode => accessCode.errorMessage)

export const { resetState } = actions
